<template>
  <el-dialog
    top="15vh"
    class="push-record-edit__dialog"
    :title="row.id ? $t('Common.edit') : $t('Common.create')"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('Message.pushContent')" prop="content">
        <!--        :style='form.content.length===500?'-->
        <el-input
          type="textarea"
          :rows="4"
          v-model="form.content"
          maxlength="500"
          show-word-limit
          :placeholder="$t('Message.pushContent')"
          :class="form && form.content && form.content.length > 499 ? 'limitLengthColor' : ''"
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('Message.pushTime')" prop="pushTime">
        <el-date-picker
          style="width: 340px"
          v-model="form.pushTime"
          type="datetime"
          :placeholder="$t('Message.pushTime')"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
        >
        </el-date-picker>
      </el-form-item>
      <!--      <el-form-item label="推送类型" prop="type">-->
      <!--        <el-radio-group v-model="form.type">-->
      <!--          <el-radio label="广告">广告</el-radio>-->
      <!--          <el-radio label="通知">通知</el-radio>-->
      <!--          <el-radio label="服务">服务</el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="点击动作" prop="clickAction">-->
      <!--        <el-radio-group v-model="form.clickAction">-->
      <!--          <el-radio :label="item.code" v-for="item in clickActionOpions" :key="item.code">-->
      <!--            {{ item.name }}-->
      <!--          </el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->
      <el-form-item :label="$t('Message.pushUser')" prop="pushUser">
        <el-radio-group v-model="form.pushUser">
          <el-radio :label="item.code" v-for="item in pushUserOptions" :key="item.code">
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('Message.productType')" prop="productType">
        <el-radio-group v-model="form.productType">
          <el-radio :label="item.code" v-for="item in productTypeOptions" :key="item.code">
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },

  data() {
    return {
      form: {},
      rules: {
        content: [{ required: true, message: this.$t('Message.pushContent'), trigger: 'blur' }],
        pushTime: [{ required: true, message: this.$t('Message.pushTime'), trigger: 'change' }],
        // type: [{ required: true, message: '请选择推送类型', trigger: 'change' }],
        // clickAction: [{ required: true, message: '请选择点击动作', trigger: 'change' }],
        pushUser: [{ required: true, message: this.$t('Message.pushUser'), trigger: 'change' }],
        productType: [
          { required: true, message: this.$t('Message.productType'), trigger: 'change' }
        ]
      },
      loading: false,
      clickActionOpions: [],
      pushUserOptions: [],
      productTypeOptions: []
    }
  },
  created() {
    this.getClickAction()
    this.getPushUser()
    this.getProductType()
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    getClickAction() {
      this.$ajax.get(this.$api.common.click_mode_select).then((res) => {
        if (res.data) {
          this.clickActionOpions = res.data
        }
      })
    },
    getPushUser() {
      this.$ajax.get(this.$api.common.app_user_type_select).then((res) => {
        if (res.data) {
          this.pushUserOptions = res.data
        }
      })
    },
    getProductType() {
      this.$ajax.get(this.$api.common.product_type_select).then((res) => {
        if (res.data) {
          this.productTypeOptions = [...res.data, { code: 'all', name: `${this.$t('Common.all')}` }]
        }
      })
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let params = {
        content: this.form.content,
        pushTime: this.form.pushTime,
        // type: this.form.type,
        // clickAction: this.form.clickAction,
        pushUser: this.form.pushUser,
        productType: this.form.productType
      }
      let api = this.$api.message.push_record_add
      this.$ajax
        .get(api, params)
        .then(() => {
          this.$message.success(
            `${this.row.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`
          )
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.push-record-edit__dialog {
  /deep/.el-dialog__body {
    padding-left: 30px;
  }
  /deep/.el-textarea .el-input__count {
    right: -60px;
    bottom: -10px;
  }
  /deep/.limitLengthColor {
    .el-input__count {
      color: red;
    }
  }
}
</style>
